import Grid from '@material-ui/core/Grid';
import { Field, useFormikContext } from 'formik';
import React, { memo, useEffect } from 'react';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';

interface IProps {
  onChange: (product_id: number) => void;
}

const Fields = memo(({ onChange }: IProps) => {
  const { values } = useFormikContext<{ product_id: number }>();

  useEffect(() => {
    if (values) onChange(values.product_id);
  }, [onChange, values]);

  return (
    <Grid container direction='row' justify='space-between'>
      <Grid xs={12}>
        <Field id='product_id' name='product_id' single fullWidth label='Produtos' component={SelectProduct} endpoint='reports/filter-all-products' />
      </Grid>
    </Grid>
  );
});

export default Fields;
